import { Component, Field } from '@contember/interface'

export const PagePreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
